 
import {
  CmpDatePickerField001V1, 
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import Grid from "@mui/material/Grid";
export default function GCHead({
  //grid saleshistory end
  vRdxWmsHead,
  sDocLoadingGrnType,
  fonSelectedGrnType,
  fGrnDate,
  fReceiptDate,
  fLocation,
  xKey,
  vRdxuserLoc,
  xErrorMsg,
  xDisableBasedOnGridDataLength,
  fTruck,
  fDriver,
}) {
  return (
    <form id="WmsLoadingReceiptHead">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
        columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid item xs={12} sm={12} md={4}  >
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={12} sm={6} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fonSelectedGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={true}
                // xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} >
              <CmpTextFieldV1
                xLabelText="Doc.No"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
                xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={5}  >
          <Grid
            container
            spacing={0.9}
            columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={6} sm={3} md={3} >
              <CmpDatePickerField001V1
                xLabelText="Receipt.Date"
                xtabIndex={"4"}
                xValue={vRdxWmsHead.A_ReceiptDt}
                xOnChange={fReceiptDate}
                xName={"A_ReceiptDt"}
                xError={xErrorMsg.A_ReceiptDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_ReceiptDt}

                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
            </Grid>
             
            <Grid item xs={6} sm={3} md={3} >
              <CmpDatePickerField001V1
               xLabelText="Doc.Date"
                xtabIndex={"2"}
                // xValue={vRdxWmsHead.A_PostDt}
                xReadOnly={true}
                xValue={vRdxWmsHead.A_PostDt}
                xOnChange={fGrnDate}
                xName={"A_PostDt"}
                xDisable={true}
                xError={xErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PostDt}
              />
            </Grid>

          
            <Grid item xs={12} sm={6} md={6}  >
            <CmpSelectFieldV1
                xtabIndex={"11"}
                xLabelText="Location"
                xValue={vRdxWmsHead.A_Loc}
                xOnChange={fLocation}
                xName={"A_Loc"}
                xData={vRdxuserLoc}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Loc === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Loc}
                xDisable={false}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3} >
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
           
            <Grid item xs={6} sm={6} md={6}  >
              <CmpTextFieldV1
               xLabelText="Truck"
                xtabIndex={"3"}
                xValue={vRdxWmsHead.Truck}
                xType={"text"} // text/number/password
                xName={"Truck"}
                xReadOnly={true}
                xOnChange={fTruck}
                xError={xErrorMsg.Truck === "" ? false : true}
                xErrorMessage={xErrorMsg.Truck}
                // xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={6} sm={6} md={6}>
               <CmpTextFieldV1
               xLabelText="Driver"
                xtabIndex={"3"}
                xValue={vRdxWmsHead.Driver}
                xType={"text"} // text/number/password
                xName={"Driver"}
                xReadOnly={true}
                xOnChange={fDriver}
                xError={xErrorMsg.Driver === "" ? false : true}
                xErrorMessage={xErrorMsg.Driver}
                // xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
